import api from './api';
import { IContrato } from '../common/interfaces/contrato.interfaces';

export function obterContratos(): Promise<IContrato[]> {
    return api.get('/contratos').then(res => res.data);
}
